<template>
  <div class="upcoming-events">
    <div class="section-header">
      <h3 class="section-title">Upcoming Events</h3>
      <v-btn x-small text color="primary" @click="$emit('view-all')">
        View All
      </v-btn>
    </div>

    <div class="events-timeline">
      <div
        v-for="event in upcomingEvents"
        :key="event.id"
        class="timeline-event"
      >
        <div class="event-time">
          <span class="time">{{ formatEventTime(event.start) }}</span>
          <span class="date">{{ formatEventDate(event.start) }}</span>
        </div>
        <div class="event-content">
          <div class="event-header">
            <span class="event-name">{{ event.name }}</span>
            <v-chip
              x-small
              :color="event.color"
              text-color="white"
              class="event-type"
            >
              {{ event.staff.Name }}
            </v-chip>
          </div>
          <div class="event-location" v-if="event.location">
            <v-icon small>mdi-map-marker</v-icon>
            {{ event.location }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "UpcomingEvents",

  props: {
    upcomingEvents: {
      type: Array,
      required: true,
    },
  },

  methods: {
    formatEventTime(date) {
      return moment(date).format("h:mm A");
    },

    formatEventDate(date) {
      return moment(date).format("MMM D");
    },
  },
};
</script>

<style lang="scss" scoped>
.upcoming-events {
  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #1e293b;
    }
  }
}

.events-timeline {
  .timeline-event {
    display: flex;
    padding: 12px;
    background: #f8fafc;
    border-radius: 12px;
    margin-bottom: 12px;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      background: #f1f5f9;
    }

    .event-time {
      margin-right: 16px;
      min-width: 80px;

      .time {
        display: block;
        font-weight: 600;
        font-size: 14px;
        color: #1e293b;
      }

      .date {
        display: block;
        font-size: 12px;
        color: #64748b;
      }
    }

    .event-content {
      flex: 1;

      .event-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 4px;

        .event-name {
          font-weight: 500;
          font-size: 14px;
        }
      }

      .event-location {
        font-size: 12px;
        color: #64748b;
        display: flex;
        align-items: center;

        .v-icon {
          margin-right: 4px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
